import { SystemField } from "./system-field";

export class Pricebook extends SystemField {
     name?:string;
     is_active?:number;
     is_standard?:number;
     for_pos?:number;
}
